<template>
	<div class="digital-clock">
		{{ hours }}<span
			v-once
			class="colon"
		>:</span>{{ minutes }}
	</div>
</template>

<script>
export default {
	name: 'DigitalClock',
	data() {
		return {
			date: new Date(),
			colon: true,
			timer: null,
		};
	},
	computed: {
		hours() {
			return this.format(this.date.getHours());
		},
		minutes() {
			return this.format(this.date.getMinutes());
		},
	},
	mounted() {
		this.timer = setInterval(() => this.tick(), 1000);
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
	methods: {
		tick() {
			this.date = new Date();
			this.colon = !this.colon;
		},
		format(unit) {
			const number = String(unit);
			if (number.length > 1) {
				return number;
			}
			return `0${number}`;
		},
	},
};
</script>

<style lang="stylus" scoped>
@keyframes fadeIn
	from
		opacity .3
	to
		opacity 1

.digital-clock
	font-size 600%

	> .colon
		animation-name fadeIn
		animation-duration 1s
		animation-direction alternate
		animation-timing-function ease-in-out
		animation-iteration-count infinite
</style>



// WEBPACK FOOTER //
// src/components/DigitalClock.vue